export default __webpack_public_path__ + "images/AnalyticsWhite.svg";